// Direction math: 8-dir (Direction, signed char) and 16-dir (Direction16, int).
// game/misc.cpp:617-649, game/GameObjects.cpp:1176-1279, game/MobileUnit.cpp:44-66,
// constants game/ht.h:1434-1455.

// game/ht.h:1436-1444
export const kdirInvalid = -1;
export const kdirN = 0;
export const kdirNE = 1;
export const kdirE = 2;
export const kdirSE = 3;
export const kdirS = 4;
export const kdirSW = 5;
export const kdirW = 6;
export const kdirNW = 7;

// game/ht.h:1447-1455
export const kdir16Invalid = -1;
export const kdir16N = 0;
export const kdir16NE = 2;
export const kdir16E = 4;
export const kdir16SE = 6;
export const kdir16S = 8;
export const kdir16SW = 10;
export const kdir16W = 12;
export const kdir16NW = 14;

// game/misc.cpp:617-632
export function TurnToward(dirTo: number, dirFrom: number): number {
  let d = dirTo - dirFrom;
  if (d === 0) return dirTo;

  if (d < -4) d = 1;
  else if (d > 4) d = -1;
  if (d < 0) dirFrom--;
  else dirFrom++;
  return (dirFrom >>> 0) % 8; // ((unsigned int)dirFrom) % 8
}

// game/misc.cpp:634-649
export function TurnToward16(dirTo: number, dirFrom: number): number {
  let d = dirTo - dirFrom;
  if (d === 0) return dirTo;

  if (d < -8) d = 1;
  else if (d > 8) d = -1;
  if (d < 0) dirFrom--;
  else dirFrom++;
  return (dirFrom >>> 0) % 16; // ((unsigned int)dirFrom) % 16
}

// game/GameObjects.cpp:1176-1222
export function CalcDir(dx: number, dy: number): number {
  const dxAbs = Math.abs(dx);
  const dyAbs = Math.abs(dy);

  if (dxAbs > dyAbs) {
    if (dx >= 0) {
      if (dy !== 0 && ((dxAbs / 2) | 0) < dyAbs) {
        // > 22.5 degrees
        return dy < 0 ? kdirNE : kdirSE;
      }
      return kdirE;
    }
    if (dy !== 0 && ((dxAbs / 2) | 0) < dyAbs) {
      // > 22.5 degrees
      return dy < 0 ? kdirNW : kdirSW;
    }
    return kdirW;
  }
  if (dy < 0) {
    if (dx !== 0 && ((dyAbs / 2) | 0) < dxAbs) {
      return dx >= 0 ? kdirNE : kdirNW;
    }
    return kdirN;
  }
  if (dx !== 0 && ((dyAbs / 2) | 0) < dxAbs) {
    return dx >= 0 ? kdirSE : kdirSW;
  }
  return kdirS;
}

// game/GameObjects.cpp:1227-1243
const s_mpnArcFromDxDy: number[][] = [
  [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  [0, 3, 2, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
  [0, 2, 3, 2, 2, 1, 1, 1, 1, 1, 1, 0, 0, 0, 0, 0],
  [0, 1, 2, 3, 3, 2, 2, 2, 1, 1, 1, 1, 1, 1, 1, 1],
  [0, 1, 2, 3, 3, 3, 2, 2, 2, 2, 1, 1, 1, 1, 1, 1],
  [0, 1, 1, 2, 3, 3, 3, 3, 2, 2, 2, 2, 2, 1, 1, 1],
  [0, 0, 1, 2, 2, 3, 3, 3, 3, 2, 2, 2, 2, 2, 2, 1],
  [0, 0, 1, 2, 2, 3, 3, 3, 3, 3, 3, 2, 2, 2, 2, 2],
  [0, 0, 1, 1, 2, 2, 3, 3, 3, 3, 3, 3, 2, 2, 2, 2],
  [0, 0, 1, 1, 2, 2, 2, 3, 3, 3, 3, 3, 3, 3, 2, 2],
  [0, 0, 1, 1, 1, 2, 2, 3, 3, 3, 3, 3, 3, 3, 3, 2],
  [0, 0, 0, 1, 1, 2, 2, 2, 3, 3, 3, 3, 3, 3, 3, 3],
  [0, 0, 0, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 3, 3, 3],
  [0, 0, 0, 1, 1, 1, 2, 2, 2, 3, 3, 3, 3, 3, 3, 3],
  [0, 0, 0, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 3, 3],
  [0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 3],
];

// game/GameObjects.cpp:1246-1249
const s_adirFromArc: number[] = [
  0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13, 14, 14,
  15, 15, 0,
];

// game/GameObjects.cpp:1251-1279
export function CalcDir16(dx: number, dy: number): number {
  let dxAbs = Math.abs(dx);
  let dyAbs = Math.abs(dy);

  while (dxAbs >= 16 || dyAbs >= 16) {
    dxAbs >>= 1;
    dyAbs >>= 1;
  }

  if (dxAbs === 0) return dy < 0 ? 0 : 8;
  if (dyAbs === 0) return dx >= 0 ? 4 : 12;

  let i = s_mpnArcFromDxDy[dyAbs][dxAbs];

  if (dxAbs >= dyAbs) i = 7 - i;
  if (dy > 0) i = 15 - i;
  if (dx < 0) i = 31 - i;

  return s_adirFromArc[i];
}

// game/MobileUnit.cpp:48-49
export const g_mpDirToDx: number[] = [0, 1, 1, 1, 0, -1, -1, -1];
export const g_mpDirToDy: number[] = [-1, -1, 0, 1, 1, 1, 0, -1];

// game/MobileUnit.cpp:58-61
export function Dir16ToDx(dir16: number): number {
  return g_mpDirToDx[(dir16 / 2) | 0];
}

// game/MobileUnit.cpp:63-66
export function Dir16ToDy(dir16: number): number {
  return g_mpDirToDy[(dir16 / 2) | 0];
}

// game/MobileUnit.cpp:68-72
export function Dir16IsDiagonal(dir16: number): boolean {
  return dir16 !== kdir16N && dir16 !== kdir16E && dir16 !== kdir16S && dir16 !== kdir16W;
}
